import React, {useEffect, useState} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const StreetContent = ({data}) => {
    const [limit, setLimit] = useState(15);

    const streets = data.streetsWithMoreAttendances || [];
    const passedLimit = streets.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prev => prev ? null : 15);
    };

    useEffect(() => {
        if (!data?.streetsWithMoreAttendances) return;
        const sorted = [...data.streetsWithMoreAttendances].sort((a, b) => b.qty - a.qty);

        const valuesExtended = sorted.map(item => ([
            item.qty,
            ReportUtils.formatText(item.street_name),
            ReportUtils.formatText(item.neighborhood_name)
        ]));

        ReportUtils.createExportableTable(["Quantidade", "Logradouro", "Bairro"], valuesExtended, "Atendimentos por endereço");

    }, [data]);

    return (
        <>
            <div className="mt-4">
                <span className="chart-title mb-3">Atendimentos por endereço {(passedLimit && limit) ? ' (TOP 15)' : ''}</span>

                <table id="attendancesByAddressData" className="table mt-2" sheet-name="Atendimentos por endereço">
                    <thead className="thead-background">
                        <tr className="text-left">
                            <th className="w-[10%]">Quantidade</th>
                            <th className="w-[50%]">Logradouro</th>
                            <th className="w-[50%]">Bairro</th>
                        </tr>
                    </thead>

                    <tbody>
                    {
                        (limit ? streets.slice(0, limit) : streets).map((element, index) => (
                            <tr key={index}>
                                <td className="w-[10%] bg-white">{element.qty}</td>
                                <td className="w-[50%] bg-white">{ReportUtils.formatText(element.street_name)}</td>
                                <td className="w-[50%] bg-white">{ReportUtils.formatText(element.neighborhood_name)}</td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>

                {
                    passedLimit &&
                    <div className="text-end mt-1">
                        <span className="see-more print-hide" onClick={seeMoreOrLess}>
                            {limit ? "Ver mais" : "Ver menos"}
                        </span>
                    </div>
                }

            </div>
        </>
    );
};

export default StreetContent;